module.exports = __webpack_public_path__ + "static/img/ali_pay.f7cad24.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/movie/ali_pay.png
// module id = I1+E
// module chunks = 1